import React from 'react';
import { Shield } from 'lucide-react';

const AuthShell = ({ eyebrow = 'Paytiemp', title, subtitle, children }) => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-100 via-violet-50 to-slate-100 px-4 py-10">
    <div className="w-full max-w-md">
      <div className="mb-6 text-center">
        <div className="mx-auto mb-4 h-14 w-14 rounded-2xl bg-primary-600 text-white shadow-sm flex items-center justify-center">
          <Shield className="h-7 w-7" />
        </div>
        <div className="text-[11px] uppercase tracking-[0.18em] text-primary-600 font-semibold">{eyebrow}</div>
        <h1 className="mt-1 text-2xl font-semibold text-slate-900">PF Claims Management</h1>
        <p className="mt-2 text-sm font-medium text-slate-700">{title}</p>
        {subtitle ? <p className="mt-1 text-sm text-slate-500">{subtitle}</p> : null}
      </div>
      <div className="bg-white border border-primary-100 shadow-sm rounded-2xl p-6 sm:p-8">
        {children}
      </div>
    </div>
  </div>
);

export default AuthShell;
